import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import Item from 'modules/contracts/components/ContractDetails/LegalAndLabour/Item'

interface Props {
  hasRemoteContract: boolean
}

const RemoteContract = ({ hasRemoteContract }: Props) => {
  const description = hasRemoteContract ? i18n.t('common.yes') : i18n.t('common.no')

  return (
    <Item
      title={i18n.t('contract_versions.legal_and_labour.spain.remote_contract')}
      description={description}
    />
  )
}

export default observer(RemoteContract)
